















import { Vue, Component } from 'vue-property-decorator';
import CamaraVOD from '@/pantallas/Camaras/VOD/CamaraVOD.vue';

@Component({
  components: { VODComponent: CamaraVOD },
})
export default class CamaraVODPantalla extends Vue {}
